(function () {
  'use strict';

  var GAP = 8;

  function positionDropdown(btn, dropdown) {
    var rect = btn.getBoundingClientRect();
    var dropH = dropdown.offsetHeight;
    var vpH = window.innerHeight;
    var spaceAbove = rect.top;
    var spaceBelow = vpH - rect.bottom;

    // Reset both so we can set cleanly
    dropdown.style.top = '';
    dropdown.style.bottom = '';

    var rightEdge = window.innerWidth - rect.right;

    if (spaceAbove >= dropH + GAP || spaceAbove >= spaceBelow) {
      // Open upward
      dropdown.style.bottom = (vpH - rect.top + GAP) + 'px';
    } else {
      // Open downward
      dropdown.style.top = (rect.bottom + GAP) + 'px';
    }

    dropdown.style.right = Math.max(rightEdge, GAP) + 'px';
  }

  function initShareButton() {
    var wrapper = document.getElementById('ProductShareButton');
    if (!wrapper) return;

    var btn = wrapper.querySelector('.product-share-btn');
    var dropdown = wrapper.querySelector('.product-share-dropdown');
    var copyBtn = wrapper.querySelector('.product-share-copy');

    if (!btn || !dropdown) return;

    function openDropdown() {
      dropdown.hidden = false;
      // Measure after unhiding so offsetHeight is real
      positionDropdown(btn, dropdown);
      dropdown.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      // Hide after transition
      setTimeout(function () {
        if (!dropdown.classList.contains('is-open')) dropdown.hidden = true;
      }, 160);
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = copyBtn.getAttribute('data-url');
        var span = copyBtn.querySelector('span');

        if (!navigator.clipboard) return;

        navigator.clipboard.writeText(url).then(function () {
          if (!span) return;
          var original = span.textContent;
          span.textContent = 'Copied!';
          setTimeout(function () {
            span.textContent = original;
            closeDropdown();
          }, 1500);
        });
      });
    }

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target) && !dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    window.addEventListener('resize', function () {
      if (dropdown.classList.contains('is-open')) positionDropdown(btn, dropdown);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareButton);
  } else {
    initShareButton();
  }
})();
